import { Entry } from "contentful";
import { useRouter } from "next/router";
import { useMemo } from "react";

import Editorials from "~/types/editorials";
import appRoutes from "~/utils/app-routes";
import { assertEditorialType } from "~/utils/editorial-utils";

import ProductCarouselAlgolia from "./product-carousel-algolia";
import ProductCarouselStatic from "./product-carousel-static";

type Props = {
  entry: Entry<unknown>;
};

export default function ProductCarouselWrapper({ entry }: Props) {
  const router = useRouter();
  const trackingPage: string = useMemo(() => {
    if (router.pathname === appRoutes.CART) {
      return "cart";
    }
    if (router.pathname === appRoutes.HOMEPAGE) {
      return "homepage";
    }
    if (router.pathname.includes("/p/")) {
      return "product_page";
    }
    return "";
  }, [router]);
  const ProductReferenceComponent = useMemo(() => {
    assertEditorialType<Editorials.ProductCarousel>(entry, "productCarousel");
    const productReferenceFields = entry.fields.products.fields;
    if (!!productReferenceFields && !Object.hasOwn(productReferenceFields, "type")) {
      return (
        <ProductCarouselStatic
          entry={entry}
          listScope={entry.sys.id}
          enableLoop={!!entry.fields.enableLoop}
          productReferenceFields={
            productReferenceFields as Editorials.ProductsReferenceById | Editorials.ProductsReferenceBySet
          }
        />
      );
    } else {
      return (
        <ProductCarouselAlgolia
          entry={entry}
          listScope={trackingPage ? `algolia_${trackingPage}` : entry.sys.id}
          enableLoop={!!entry.fields.enableLoop}
          productReferenceFields={productReferenceFields as Editorials.ProductsAlgoliaRecommender}
        />
      );
    }
  }, [entry, trackingPage]);
  return <>{ProductReferenceComponent}</>;
}
